import { render } from "./NImageViewer.vue?vue&type=template&id=51d5bfa3&ts=true"
import script from "./NImageViewer.vue?vue&type=script&lang=ts"
export * from "./NImageViewer.vue?vue&type=script&lang=ts"

import "./NImageViewer.vue?vue&type=style&index=0&id=51d5bfa3&lang=css"
import "./NImageViewer.vue?vue&type=style&index=1&id=51d5bfa3&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__